import React from 'react';
import { useTranslation } from 'react-i18next';
import SuccessIcon from '../Icons/SuccessIcon';

interface Props {
  toggleSuccesModal(): void;
  filename: string;
}

const SuccessModalBatch: React.FC<Props> = ({ toggleSuccesModal, filename }) => {
  const { t } = useTranslation(['includeTeam']);

  return (
    <div className="success-wrapper" data-testid="success-many-modal">
      <div className="icon-wrapper">
        <SuccessIcon />
      </div>
      <span className="title-success">{t('includeTeam:file_success_title')}</span>
      <span className="subtitle">{t('includeTeam:ongoing')}</span>
      <button type="button" className="ok-button" onClick={toggleSuccesModal}>
        Fazer novo pedido
      </button>
    </div>
  );
};

export default SuccessModalBatch;
